import {
    Container,
    MenuItem,
    SvgIcon,
    Grid,
    Paper,
    TablePagination,
    Divider,
    Select,
    Popover,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Switch,
    FormControlLabel,
    CircularProgress
} from "@mui/material";
import { KeyboardBackspace, KeyboardArrowLeft, KeyboardArrowRight, SettingsPowerTwoTone, MarginTwoTone } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import * as React from 'react';
import { useCallback } from 'react';
import { ReactComponent as CalendarIcon } from "../../assets/ico_calendar.svg";
import Autocomplete from '@mui/material/Autocomplete';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { IUserDetails, ITotalUsers, ITotalUsersIncrease, ITotalRevenue, RevenueIncreasePercentage, TotalGoogleVisit, TotalGoogleIncreasePercentage, TotalUsers, TotalRevenueSum } from "../../redux/api/types";
import { useGetTotalUsersQuery, useGetTotalUsersIncreaseQuery, useGetTotalRevenueQuery, useGetRevenueIncreasePercentageQuery, useGetTotalGoogleVisitQuery, useGetTotalGoogleIncreasePercentageQuery, useGetTotalCountUsersQuery, useGetTotalRevenueSumQuery } from "../../redux/api/paymentApi";
import { useActiveUserMutation, useDeactiveUserMutation, useUsersListMutation, useGetPartnerListQuery, useUpdateUserAsPartnerAdminMutation, useAddPartnerMutation } from "../../redux/api/authApi";
import { isBrowser, isMobile, MobileView, BrowserView } from "react-device-detect";
import { useState, useEffect } from "react";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { IProductHeadings } from "../../redux/api/types";
import { useLazySearchProductQuery } from "../../redux/api/productApi";
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import { ToastContainer, toast } from "react-toastify";
import { AutocompleteChangeReason, AutocompleteChangeDetails } from '@mui/material/Autocomplete';
import {
    startOfDay,
    endOfDay,
    subDays,
    subMonths,
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    addDays,
    format,
} from 'date-fns';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
import Tooltip from "@mui/material/Tooltip";
import './dashboard_admin.css';
import FilterListIcon from '@mui/icons-material/FilterList';
import { ReactComponent as ArrowLineUpRightIcon } from '../../assets/admin_dashboard/arrowLineUpRight.svg';
import { ReactComponent as BlogsIcon } from '../../assets/admin_dashboard/blogs_icon.svg';
import { ReactComponent as ImagesIcon } from '../../assets/admin_dashboard/images_icon.svg';
import { ReactComponent as VideosIcon } from '../../assets/admin_dashboard/videos_icon.svg';
import { ReactComponent as VideoClipIcon } from '../../assets/admin_dashboard/video_clips_icon.svg';
import { ReactComponent as AudioIcon } from '../../assets/admin_dashboard/audio_icon.svg';
import { ReactComponent as AudioClipIcon } from '../../assets/admin_dashboard/audio_clips_icon.svg';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { LineChart, lineElementClasses } from '@mui/x-charts/LineChart';
import Pagination from "@mui/material/Pagination";
import { differenceInDays, differenceInMonths, differenceInHours, parseISO } from 'date-fns';
import axios from 'axios';


/* const xLabels = [
    'Page A',
    'Page B',
    'Page C',
    'Page D',
    'Page E',
    'Page F',
    'Page G',
]; */
// Generate dates dynamically with 9-day intervals
const getDateLabels = () => {
    const today = new Date(); // Current date
    const labels = [];

    for (let i = 0; i < 3; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i * 9); // Add 9 days interval
        labels.push(
            date.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
            })
        );
    }

    return labels;
};

const xLabels = getDateLabels();

const DashboardNew = () => {
    const customInputStyle = {
        color: 'Black',
        border: '1px solid #CBCBCB',
    };
    // Column widths for the "looks like a table" div/grid layout used in the
    // browser view below. Kept as one constant so the header row and every
    // data row always line up.
    const userTableGridColumns = '1.1fr 0.9fr 1fr 1.6fr 1.2fr 0.9fr 0.8fr 1.3fr 0.8fr';

    const StyledButton = styled(IconButton)(({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
    }));
    const StyledDay = styled(PickersDay)(({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        color:
            theme.palette.mode === 'dark'
                ? theme.palette.primary.dark
                : theme.palette.primary.light,
    }));


    const [userlists, setuserlists] = useState<IUserDetails[] | undefined>(undefined);
    const [adminDatas, setAdminDatas] = useState<any>();
    const [userRecords, setUserRecords] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    // const pageSize = isMobile ? 5 : 10;
    const [pageSize, setPageSize] = useState(isMobile ? 5 : 10);
    const [searchText, setSearchText] = useState('');
    const [paidUsers, setPaidUsers] = useState(0);
    const [freeUsers, setFreeUsers] = useState(0);



    //predefined ranges
    /*  const [selectedRange, setSelectedRange] = useState<string>('thisWeek');
     const [dateRange, setDateRange] = useState<Date[] | null>(getDateRange(selectedRange)); */
    const [selectedRange, setSelectedRange] = useState<string>('thisWeek');
    const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
        startDate: '',
        endDate: '',
    });

    const [selectedPrevRange, setSelectedPrevRange] = useState('previous_week');

    const [UsersListMutation, { isLoading: isUserListLoading }] = useUsersListMutation();
    const [ActivateUserMutation] = useActiveUserMutation();
    const [DeactivateUserMutation] = useDeactiveUserMutation();
    const { data: partnerData, refetch: refetchPartnerList } = useGetPartnerListQuery(undefined, {
        refetchOnFocus: false,
        refetchOnReconnect: false,
    });
    const [updateUserAsPartnerAdmin] = useUpdateUserAsPartnerAdminMutation();
    const [openPartnerFor, setOpenPartnerFor] = useState<string | null>(null);

    // ---- Add New Partner modal state ----
    const [addPartner, { isLoading: isAddingPartner }] = useAddPartnerMutation();
    const [isAddPartnerModalOpen, setIsAddPartnerModalOpen] = useState(false);
    const [newPartnerName, setNewPartnerName] = useState('');
    const [newPartnerStatus, setNewPartnerStatus] = useState(true); // true => status 1 (Active), false => status 0 (Inactive)
    const [newPartnerNameError, setNewPartnerNameError] = useState('');

    const handleOpenAddPartnerModal = () => {
        setNewPartnerName('');
        setNewPartnerStatus(true);
        setNewPartnerNameError('');
        setIsAddPartnerModalOpen(true);
    };

    const handleCloseAddPartnerModal = () => {
        if (isAddingPartner) return; // don't allow closing mid-request
        setIsAddPartnerModalOpen(false);
    };

    const handleAddPartnerSubmit = async () => {
        if (!newPartnerName.trim()) {
            setNewPartnerNameError('Partner name is required');
            return;
        }

        try {
            const result = await addPartner({
                partner_name: newPartnerName.trim(),
                status: newPartnerStatus ? 1 : 0,
            }).unwrap();

            toast.success(result?.status || 'Partner added successfully');
            setIsAddPartnerModalOpen(false);
            setNewPartnerName('');
            setNewPartnerStatus(true);
            refetchPartnerList();
        } catch (error) {
            console.error('Error adding new partner:', error);
            toast.error('Failed to add partner');
        }
    };

    const [selectedPartners, setSelectedPartners] = useState<{
        [email: string]: string;
    }>({});

    const handlePartnerChange = async (
        user: IUserDetails,
        partner: string
    ) => {

        // Update UI immediately
        setSelectedPartners(prev => ({
            ...prev,
            [user.email]: partner,
        }));

        try {
            const response = await updateUserAsPartnerAdmin({
                userid: user._id,
                partner,
            }).unwrap();

            if (response.status === "updated") {
                toast.success("Partner updated successfully");

                setuserlists(prev =>
                    prev?.map(item =>
                        item._id === user._id
                            ? {
                                ...item,
                                partner,
                                partner_type: partner
                                    ? "Associate admin"
                                    : "Associate user",
                            }
                            : item
                    )
                );
            }else{
                toast.success("Failed to update Partner");
            }
        } catch (err) {
            toast.error("Failed to update partner");
        }
    };

    const handleActivateUser = useCallback(async (email: string, iindex: number, uuserlist: IUserDetails[]) => {
        try {

            const isConfirmed = window.confirm('Are you sure you want to activate this user?');
            // If the user confirms, proceed with activation
            if (isConfirmed) {
                const response = await ActivateUserMutation({ email });
                if ('data' in response) {
                    const data = response.data;
                    if (data.status === 'success') {
                        toast.success('User activated successfully');
                        // After successful activation, update userlists
                        const updatedUserList = uuserlist.map((user, index) =>
                            index === iindex ? { ...user, status: 'active' } : user
                        );
                        console.log('After update:', updatedUserList);
                        setuserlists(updatedUserList);
                    } else {
                        toast.error('Failed to activate user');
                    }
                } else {
                    toast.error('Failed to activate user');
                }
            }
        } catch (error) {
            console.error('Error activating user', error);
            toast.error('An error occurred while activating the user');
        }
    }, [ActivateUserMutation]);

    const handleDeactivateUser = useCallback(async (email: string, iindex: number, uuserlist: IUserDetails[]) => {
        try {

            // Display a confirmation dialog
            const isConfirmed = window.confirm('Are you sure you want to deactivate this user?');
            // If the user confirms, proceed with activation
            if (isConfirmed) {
                const response = await DeactivateUserMutation({ email });
                console.log('deactivated user=>', data);
                if ('data' in response) {
                    const data = response.data;
                    if (data.status === 'success') {
                        toast.success('Deactivated successfully');
                        // After successful activation, update userlists
                        const updatedUserList = uuserlist.map((user, index) =>
                            index === iindex ? { ...user, status: 'inactive' } : user
                        );
                        console.log('After update:', updatedUserList);
                        setuserlists(updatedUserList);
                    }
                    else {
                        toast.error('Failed to deactivate user');
                    }
                } else {
                    toast.error('Failed to deactivate user');
                }

            }

        } catch (error) {
            console.error('Error activating user', error);
            toast.error('An error occurred while activating the user');
        }

    }, [DeactivateUserMutation]);

    /* useEffect(() => {
      setuserlists(data?.userdet);
    }, [data]) */

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [fromDate, setFromDate] = useState<Date | null>(null);
    const [toDate, setToDate] = useState<Date | null>(null);

    const [customerFromDate, setCustomerFromDate] = useState('');
    const [customerToDate, setCustomerToDate] = useState('');
    const [options, setOptions] = useState<IProductHeadings[]>([]);
    const [searchProduct, searchState] = useLazySearchProductQuery();
    const [filter, setFilter] = useState<IProductHeadings | null>(null);
    const [active, setActive] = useState("7 days");
    const [fromDatefromActiveTab, setFromDatefromActiveTab] = useState<any>();
    const [toDatefromActiveTab, setToDatefromActiveTab] = useState<any>();
    const [xLabels, setXLabels] = useState<string[]>([]);
    const [paidUserData, setPaidUserData] = useState<number[]>([]);
    const [freeUserData, setFreeUserData] = useState<number[]>([]);
    const [totalUserData, setTotalUserData] = useState<number[]>([]);

    const filteroptions = ["7 days", "30 days", "12 month", "24 hours"];

    useEffect(() => {
        searchProduct("");
    }, []);


    const handlePrevRangeChange = (event: React.ChangeEvent<{ value: string }>) => {
        const newMode: string = event.target.value;
        setSelectedPrevRange(newMode);
    }

    const currentWeekStart = format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd');
    const currentWeekEnd = format(endOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd');

    const [productVal, setproductVal] = useState('');
    const [totalusers, setTotalUsers] = useState<ITotalUsers | undefined>(undefined);
    const [totalusersincrease, setTotalUsersIncrease] = useState<ITotalUsersIncrease | undefined>(undefined);
    const [totalRevenue, setTotalRevenue] = useState<ITotalRevenue | undefined>(undefined);
    const [totalCountusers, setTotalCountUsers] = useState<TotalUsers | undefined>(undefined);
    const [totalRevenueSum, setTotalRevenueSum,] = useState<TotalRevenueSum | undefined>(undefined);
    const [revenueincreasepercentage, setRevenueIncreasePercentage] = useState<RevenueIncreasePercentage | undefined>(undefined);
    const [totalgooglevisit, setTotalGoogleVisit] = useState<TotalGoogleVisit | undefined>(undefined);
    const [totalgoogleincreasepercentage, setTotalGoogleIncreasePercentage] = useState<TotalGoogleIncreasePercentage | undefined>(undefined);

    const { data, isSuccess, isError } = useGetTotalUsersQuery({ from_date: fromDatefromActiveTab/* fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate ? dateRange.startDate : currentWeekStart */, to_date: toDatefromActiveTab/* toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate ? dateRange.endDate : currentWeekEnd */, mode: ''/* selectedPrevRange */, product: /* productVal */ '' }, { refetchOnFocus: false, refetchOnReconnect: false });
    const userincreasedata = useGetTotalUsersIncreaseQuery({ from_date: fromDatefromActiveTab/* fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate ? dateRange.startDate : currentWeekStart */, to_date: toDatefromActiveTab/* toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate ? dateRange.endDate : currentWeekEnd */, mode: ''/* selectedPrevRange */, product: ''/* productVal */ }, { refetchOnFocus: false, refetchOnReconnect: false });
    const revenuedata = useGetTotalRevenueQuery({ from_date: fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate ? dateRange.startDate : currentWeekStart, to_date: toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate ? dateRange.endDate : currentWeekEnd, mode: selectedPrevRange, product: productVal }, { refetchOnFocus: false, refetchOnReconnect: false });
    const totalUsersCount = useGetTotalCountUsersQuery({}, { refetchOnFocus: false, refetchOnReconnect: false });
    const totalRevenueSumCount = useGetTotalRevenueSumQuery({}, { refetchOnFocus: false, refetchOnReconnect: false });
    const revenueincreasedata = useGetRevenueIncreasePercentageQuery({ from_date: fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate ? dateRange.startDate : currentWeekStart, to_date: toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate ? dateRange.endDate : currentWeekEnd, mode: selectedPrevRange, product: productVal }, { refetchOnFocus: false, refetchOnReconnect: false });
    const totalgoogledata = useGetTotalGoogleVisitQuery({ from_date: fromDatefromActiveTab/* fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate ? dateRange.startDate : currentWeekStart */, to_date: toDatefromActiveTab/* toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate ? dateRange.endDate : currentWeekEnd */, mode: ''/* selectedPrevRange */, product: ''/* productVal */ }, { refetchOnFocus: false, refetchOnReconnect: false });
    const totalgooglepercentagedata = useGetTotalGoogleIncreasePercentageQuery({ from_date: fromDatefromActiveTab/* fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : dateRange.startDate ? dateRange.startDate : currentWeekStart */, to_date: toDatefromActiveTab/* toDate ? format(new Date(toDate), 'yyyy-MM-dd') : dateRange.endDate ? dateRange.endDate : currentWeekEnd */, mode: ''/* selectedPrevRange */, product: ''/* productVal */ }, { refetchOnFocus: false, refetchOnReconnect: false });


    useEffect(() => {
        if (searchState.data) {
            setOptions(searchState.data);
        }
    }, [searchState]);

    useEffect(() => {
        const formattedDateRange = getDateRange(selectedRange);
        setDateRange(formattedDateRange);
        console.log(formattedDateRange.startDate);
        console.log(formattedDateRange.endDate);
    }, [selectedRange]);

    const handleRangeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const newRange = event.target.value as string;
        setSelectedRange(newRange);
    }


    function getDateRange(range: string): { startDate: string; endDate: string } {
        const currentDate = new Date();
        let startDate: Date;
        let endDate: Date;

        switch (range) {
            case 'today':
                startDate = startOfDay(currentDate);
                endDate = endOfDay(currentDate);
                break;
            case 'yesterday':
                const yesterday = subDays(currentDate, 1);
                startDate = startOfDay(yesterday);
                endDate = endOfDay(yesterday);
                break;
            case 'last7Days':
                const last7DaysStartDate = subDays(currentDate, 7);
                startDate = startOfDay(last7DaysStartDate);
                endDate = endOfDay(currentDate);
                break;
            case 'last30Days':
                const last30DaysStartDate = subDays(currentDate, 30);
                startDate = startOfDay(last30DaysStartDate);
                endDate = endOfDay(currentDate);
                break;
            case 'thisMonth':
                startDate = startOfMonth(currentDate);
                endDate = endOfMonth(currentDate);
                break;
            case 'lastMonth':
                const lastMonthStartDate = startOfMonth(subMonths(currentDate, 1));
                const lastMonthEndDate = endOfMonth(subMonths(currentDate, 1));
                startDate = lastMonthStartDate;
                endDate = lastMonthEndDate;
                break;
            case 'thisWeek':
                const thisWeekStartDate = startOfWeek(currentDate);
                const thisWeekEndDate = endOfWeek(currentDate);
                startDate = thisWeekStartDate;
                endDate = thisWeekEndDate;
                break;
            default:
                startDate = new Date(); // You can provide a default value here
                endDate = new Date(); // You can provide a default value here
                break;
        }

        const formattedStartDate = format(startDate, 'yyyy-MM-dd');
        const formattedEndDate = format(endDate, 'yyyy-MM-dd');

        return {
            startDate: formattedStartDate,
            endDate: formattedEndDate,
        };
    }



    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    useEffect(() => {
        if (fromDate && toDate) {
            setCustomerFromDate(format(fromDate, 'yyyy-MM-dd'));
            setCustomerToDate(format(toDate, 'yyyy-MM-dd'));
            setActive(''); 
        }
    }, [fromDate, toDate]);


    const handlecustoFromDate = (date: any) => {
        setCustomerFromDate(date);
    }

    const handlecustoToDate = (date: any) => {
        setCustomerToDate(date);
    }

    const handleProductChange = (
        event: React.ChangeEvent<{}>,
        value: IProductHeadings | null,
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<{}> | undefined
    ) => {
        if (value) {
            // Assuming IProductHeadings has a property like 'product_module'
            setproductVal(value.product_module);
        } else {
            // Handle the case where value is null
            setproductVal('');
        }
    };

    useEffect(() => {
        console.log(userlists);
        console.log(userRecords);
        setTotalUsers(data as ITotalUsers | undefined);
        setTotalUsersIncrease(userincreasedata.data as ITotalUsersIncrease | undefined);
        setTotalRevenue(revenuedata.data as ITotalRevenue | undefined);
        setTotalCountUsers(totalUsersCount.data as TotalUsers | undefined);
        setTotalRevenueSum(totalRevenueSumCount.data as TotalRevenueSum | undefined);
        setRevenueIncreasePercentage(revenueincreasedata.data as RevenueIncreasePercentage | undefined);
        setTotalGoogleVisit(totalgoogledata.data as TotalGoogleVisit | undefined);
        setTotalGoogleIncreasePercentage(totalgooglepercentagedata.data as TotalGoogleIncreasePercentage | undefined);
    }, [userlists, userRecords, data, userincreasedata, revenuedata, revenueincreasedata, totalgoogledata, totalgooglepercentagedata])


    const fetchUserList = useCallback(async () => {
        try {

            let fromDate = customerFromDate ? format(new Date(customerFromDate), 'yyyy-MM-dd') : '';
            let toDate = customerToDate ? format(new Date(customerToDate), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');

            if (active === '7 days') {
                fromDate = format(subDays(new Date(), 6), 'yyyy-MM-dd');
                toDate = format(new Date(), 'yyyy-MM-dd');
            } else if (active === '30 days') {
                fromDate = format(subDays(new Date(), 29), 'yyyy-MM-dd');
                toDate = format(new Date(), 'yyyy-MM-dd');
            } else if (active === '12 month') {
                fromDate = format(subDays(subMonths(new Date(), 12), 1), 'yyyy-MM-dd');
                toDate = format(new Date(), 'yyyy-MM-dd');
            } else if (active === '24 hours') {
                fromDate = format(subDays(new Date(), 1), 'yyyy-MM-dd');
                toDate = format(new Date(), 'yyyy-MM-dd');
            }

            setFromDatefromActiveTab(fromDate);
            setToDatefromActiveTab(toDate);

            const response: any = await UsersListMutation({
                skip: (currentPage - 1) * pageSize,
                limit: pageSize,
                from_date: fromDate || ''/* customerFromDate ? format(new Date(customerFromDate), 'yyyy-MM-dd') : '' */,
                to_date: toDate || ''/* customerToDate ? format(new Date(customerToDate), 'yyyy-MM-dd') : '' */,
                search_str: searchText
            });
            const userValues = response.data.userdet;
            setuserlists(userValues);

            // paid users count based on plan_name
            const usersWithPlan = userValues?.filter((user: any) => user.plan_name !== null)?.length || 0;
            setPaidUsers(usersWithPlan);

            // free users count based on free_plan
            const userswithoutplan = userValues?.filter((user: any) => user.free_plan === 1)?.length || 0;
            setFreeUsers(userswithoutplan);

            const userRec = response.data;
            setUserRecords(userRec.totalrecords);

        } catch (error) {
            console.error('Error generating blog:', error);

        }
    }, [UsersListMutation, currentPage, pageSize, customerFromDate, customerToDate, searchText, active]);

    useEffect(() => {
        fetchUserList();
    }, [fetchUserList]);

    // Manual reload triggered by the Refresh button, independent of the
    // auto-fetch above. Lets the user force a fresh pull without changing
    // any filter/pagination state.
    const handleRefreshUserList = () => {
        fetchUserList();
    };

    const generateDateRange = (from: Date, to: Date) => {
        const range: string[] = [];
        let current = new Date(from);
        while (current <= to) {
            range.push(format(current, 'yyyy-MM-dd'));
            current.setDate(current.getDate() + 1);
        }
        return range;
    };

    /* const mapCounts = (source: any[], xAxis: string[]) => {
        return xAxis.map(date => {
            const match = source.find(item => item._id === date);
            return match ? match.count : 0;
        });
    }; */
    const mapCounts = (source: any[], xAxis: string[]) => {
        return xAxis.map(date => {
            const match = source.find(item => format(new Date(item._id), 'yyyy-MM-dd') === date);
            return match ? match.count : 0;
        });
    };

    useEffect(() => {
        const fetchdata = async () => {
            try {

                let fromDate = customerFromDate ? format(new Date(customerFromDate), 'yyyy-MM-dd') : '';
                let toDate = customerToDate ? format(new Date(customerToDate), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');

                if (active === '7 days') {
                    fromDate = format(subDays(new Date(), 6), 'yyyy-MM-dd');
                    toDate = format(new Date(), 'yyyy-MM-dd');
                } else if (active === '30 days') {
                    fromDate = format(subDays(new Date(), 29), 'yyyy-MM-dd');
                    toDate = format(new Date(), 'yyyy-MM-dd');
                } else if (active === '12 month') {
                    fromDate = format(subDays(subMonths(new Date(), 12), 1), 'yyyy-MM-dd');
                    toDate = format(new Date(), 'yyyy-MM-dd');
                } else if (active === '24 hours') {
                    fromDate = format(subDays(new Date(), 1), 'yyyy-MM-dd');
                    toDate = format(new Date(), 'yyyy-MM-dd');
                }

                setFromDatefromActiveTab(fromDate);
                setToDatefromActiveTab(toDate);

                const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
                const response = await axios.post(`${apiUrl}/api/auth/getDashBoardDetails/?from_date=${fromDate}&to_date=${toDate}&search_str=${searchText}&product=${''}`, null,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                const chartdata = response.data;
                setAdminDatas(response.data);

                const dateRange = generateDateRange(new Date(fromDate), new Date(toDate));
                setXLabels(dateRange);

                setPaidUserData(mapCounts(chartdata.datewaiseTotalPaidUsers, dateRange));
                setFreeUserData(mapCounts(chartdata.datewaiseTotalFreeUsers || [], dateRange));
                setTotalUserData(mapCounts(chartdata.datewaiseTotalUsers || [], dateRange));

            } catch (error) {
                console.error('Error generating admin datas:', error);

            }
        }
        fetchdata();
    }, [currentPage, pageSize, customerFromDate, customerToDate, searchText, active]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.target.value);
    };

    /*commented by sara*/
    // useEffect(() => {
    //   if (userlists) {
    //     const userhistory = userlists.map((users, index) => ({
    //       ...users,
    //       serialNumber: (currentPage - 1) * pageSize + index + 1,
    //     }));
    //     setuserlists(userhistory);
    //   }
    // }, [userlists]);
    /*commented by sara*/


    // Pagination
    let totalPages = Math.ceil(parseInt(userRecords) / pageSize);

    /* const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    }

    const handlePrevPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
    } */

    const generatePageNumbers = (totalPages: number, currentPage: number): (number | '...')[] => {
        const pageNumbers: (number | '...')[] = [];
        for (let i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || Math.abs(i - currentPage) < 3) {
                pageNumbers.push(i);
            } else if (pageNumbers[pageNumbers.length - 1] !== '...') {
                pageNumbers.push('...');
            }
        }
        return pageNumbers;
    };

    const pageNumbers = generatePageNumbers(totalPages, currentPage);
    //


    // Filter the userlists based on the searchText
    /* const filteredUsers = userlists ? userlists.filter(user => {
      const search = searchText.toLowerCase();
      return user.name.toLowerCase().includes(search) ||
        user.email.toLowerCase().includes(search) ||
        user.initial_product.toLowerCase().includes(search);
    }) : []; */

    const uData: (number | null)[] = [
        paidUsers ?? null,
        freeUsers ?? null,
        totalusers?.totalrecords ?? null,
    ];


    return (
        <>
            <div style={{ background: '#F5F5F5' }}>
                <div style={{ marginRight: '3%', marginLeft: '3%' }}>

                    <div className="row d-flex align-items-center justify-content-between">
                        <div className="col-sm-12 col-md-6 col-lg-6" style={{ marginTop: '2%' }}>
                            <p style={{ fontWeight: 'bold', fontSize: '24px', color: '#0B0C14' }}>Your OverView</p>
                        </div>

                        {isMobile ? <div className="col-sm-12" style={{ marginTop: '1%' }}>
                            <div className="toggle-group-admin" style={{ width: '100%' }}>
                                {filteroptions.map((option: any) => (
                                    <button
                                        key={option}
                                        className={active === option ? "active" : ""}
                                        onClick={() => setActive(option)}
                                        style={{ width: '25%' }}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div>
                        </div> : ''}

                        <div className="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end gap-2" style={{ marginTop: isMobile ? '1%' : '2%' }}>
                            {!isMobile ? <div className="toggle-group-admin">
                                {filteroptions.map((option: any) => (
                                    <button
                                        key={option}
                                        className={active === option ? "active" : ""}
                                        onClick={() => setActive(option)}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div> : ''}
                            <div onClick={handleOpen} style={{ border: '1px solid #ccc', borderRadius: '8px', color: '#000', display: 'inline-flex', overflow: 'hidden', background: '#fff', padding: '8px 14px', width: isMobile ? '70%' : '', cursor: 'pointer' }}>
                                <FilterListIcon />{fromDatefromActiveTab && toDatefromActiveTab
                                    ? `${format(new Date(fromDatefromActiveTab), 'dd MMM, yyyy')} - ${format(new Date(toDatefromActiveTab), 'dd MMM, yyyy')}`
                                    : 'Select date range'}{/* {fromDatefromActiveTab && toDatefromActiveTab ? `${format(new Date(fromDatefromActiveTab), 'dd MMM')}. - ${format(new Date(toDatefromActiveTab), 'dd MMM')}.` : ''} */}
                            </div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Popover
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                >
                                    <Box p={2} display="flex" flexDirection="column" gap={2}>
                                        <DatePicker
                                            label="From Date"
                                            value={fromDate}
                                            onChange={(newValue) => setFromDate(newValue)}
                                            slotProps={{ textField: { size: 'small' } }}
                                        />
                                        <DatePicker
                                            label="To Date"
                                            value={toDate}
                                            onChange={(newValue) => setToDate(newValue)}
                                            slotProps={{ textField: { size: 'small' } }}
                                        />
                                    </Box>
                                </Popover>
                            </LocalizationProvider>
                            {/* <div style={{ border: '1px solid #ccc', borderRadius: '8px', color: '#000', display: 'inline-flex', overflow: 'hidden', background: '#fff', padding: '8px 14px', width: isMobile ? '30%' : '' }}>
                                Source
                            </div> */}
                        </div>
                    </div>

                    <div className="row d-flex align-items-center justify-content-between" style={{ marginTop: isMobile ? "2%" : "1%" }}>

                        {/* <div className="col-sm-12 col-md-3 col-md-3">
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box-admin">
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            TOTAL VISITS
                                        </Typography>
                                        <ArrowLineUpRightIcon />
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {totalgooglevisit ? totalgooglevisit.total_google_visit : 0}
                                        </Typography>
                                        <div className="card-div-admin">
                                            <Typography sx={{ color: '#68C77D', fontWeight: '12px', fontSize: '12px' }}>{totalgoogleincreasepercentage ? "+" + totalgoogleincreasepercentage.total_google_visit_increment_percent + "% increase" : '0% increase'}</Typography>
                                        </div>
                                    </Box>

                                    <Box sx={{ border: '1px solid #ccc', borderRadius: '5px' }}>
                                        <LineChart
                                            width={isMobile ? 500 : 330}
                                            height={300}
                                            series={[
                                                {
                                                    data: uData,
                                                    area: true,
                                                    showMark: false,
                                                    color: '#4BA5EB', // Main line color
                                                },
                                            ]}
                                            xAxis={[
                                                {
                                                    scaleType: 'point',
                                                    data: xLabels, // Dynamically generated labels
                                                },
                                            ]}
                                            yAxis={[
                                                {
                                                    valueFormatter: (value) =>
                                                        value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value, // Format 1k, 3k, 5k
                                                },
                                            ]}
                                            grid={{ vertical: false, horizontal: true }}
                                            sx={{
                                                '& path[fill^="#4BA5EB"]': {
                                                    fill: '#4BA5EB',
                                                    fillOpacity: 0.2, // Partial transparency
                                                },
                                                '& .MuiChartsAxis-line': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsAxis-tick': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsGrid-line': {
                                                    stroke: '#B1B1B1',
                                                    strokeDasharray: '0',
                                                },
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Card>
                        </div> */}

                        <div className="col-sm-12 col-md-4 col-md-4" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box-admin">
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            TOTAL PAID USER
                                        </Typography>
                                        <ArrowLineUpRightIcon />
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {/* {paidUsers} */}
                                            {adminDatas?.totalPaidUsers}
                                        </Typography>
                                        <div className="card-div-admin">
                                            <Typography sx={{ color: adminDatas?.totaldatewaisePaidUsersPercentage >= 0 ? '#68C77D' : 'red', fontWeight: '12px', fontSize: '12px' }}>{`${adminDatas?.totaldatewaisePaidUsersPercentage >= 0 ? '+' : ''}${Number(adminDatas?.totaldatewaisePaidUsersPercentage)?.toFixed(2)}% ${adminDatas?.totaldatewaisePaidUsersPercentage >= 0 ? 'increase' : 'decrease'}`}</Typography>
                                        </div>
                                    </Box>

                                    <Box sx={{ border: '1px solid #ccc', borderRadius: '5px' }}/* className="box1-admin" */>
                                        {/* <LineChart
                                            width={isMobile ? 500 : 430}
                                            height={300}
                                            series={[
                                                {
                                                    data: uData,
                                                    area: true,
                                                    showMark: false,
                                                    color: '#4BA5EB', // Main line color
                                                },
                                            ]}
                                            xAxis={[
                                                {
                                                    scaleType: 'point',
                                                    data: xLabels, // Dynamically generated labels
                                                },
                                            ]}
                                            yAxis={[
                                                {
                                                    valueFormatter: (value) =>
                                                        value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value, // Format 1k, 3k, 5k
                                                },
                                            ]}
                                            grid={{ vertical: false, horizontal: true }}
                                            sx={{
                                                '& path[fill^="#4BA5EB"]': {
                                                    fill: '#4BA5EB',
                                                    fillOpacity: 0.2, // Partial transparency
                                                },
                                                '& .MuiChartsAxis-line': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsAxis-tick': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsGrid-line': {
                                                    stroke: '#B1B1B1',
                                                    strokeDasharray: '0',
                                                },
                                            }}
                                        /> */}
                                        <LineChart
                                            width={isMobile ? 500 : 430}
                                            height={300}
                                            series={[{
                                                data: paidUserData,
                                                area: true,
                                                showMark: false,
                                                color: '#4BA5EB',
                                            }]}
                                            xAxis={[{ scaleType: 'point', data: xLabels }]}
                                            yAxis={[{
                                                valueFormatter: value => value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value,
                                            }]}
                                            grid={{ vertical: false, horizontal: true }}
                                            sx={{
                                                '& path[fill^="#4BA5EB"]': {
                                                    fill: '#4BA5EB',
                                                    fillOpacity: 0.2,
                                                },
                                                '& .MuiChartsAxis-line, & .MuiChartsAxis-tick': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsGrid-line': {
                                                    stroke: '#B1B1B1',
                                                    strokeDasharray: '0',
                                                },
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Card>
                        </div>

                        <div className="col-sm-12 col-md-4 col-md-4" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box-admin">
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            TOTAL FREE USERS
                                        </Typography>
                                        <ArrowLineUpRightIcon />
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {/* {freeUsers} */}
                                            {adminDatas?.totalFreeUsers}
                                        </Typography>
                                        <div className="card-div-admin">
                                            <Typography sx={{ color: adminDatas?.totaldatewaiseFreeUsersPercentage >= 0 ? '#68C77D' : 'red', fontWeight: '12px', fontSize: '12px' }}>{`${adminDatas?.totaldatewaiseFreeUsersPercentage >= 0 ? '+' : ''}${Number(adminDatas?.totaldatewaiseFreeUsersPercentage)?.toFixed(2)}% ${adminDatas?.totaldatewaiseFreeUsersPercentage >= 0 ? 'increase' : 'decrease'}`}</Typography>
                                        </div>
                                    </Box>

                                    <Box sx={{ border: '1px solid #ccc', borderRadius: '5px' }}/* className="box1-admin" */>
                                        {/* <LineChart
                                            width={isMobile ? 500 : 430}
                                            height={300}
                                            series={[
                                                {
                                                    data: uData,
                                                    area: true,
                                                    showMark: false,
                                                    color: '#4BA5EB', // Main line color
                                                },
                                            ]}
                                            xAxis={[
                                                {
                                                    scaleType: 'point',
                                                    data: xLabels, // Dynamically generated labels
                                                },
                                            ]}
                                            yAxis={[
                                                {
                                                    valueFormatter: (value) =>
                                                        value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value, // Format 1k, 3k, 5k
                                                },
                                            ]}
                                            grid={{ vertical: false, horizontal: true }}
                                            sx={{
                                                '& path[fill^="#4BA5EB"]': {
                                                    fill: '#4BA5EB',
                                                    fillOpacity: 0.2, // Partial transparency
                                                },
                                                '& .MuiChartsAxis-line': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsAxis-tick': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsGrid-line': {
                                                    stroke: '#B1B1B1',
                                                    strokeDasharray: '0',
                                                },
                                            }}
                                        /> */}
                                        <LineChart
                                            width={isMobile ? 500 : 430}
                                            height={300}
                                            series={[{
                                                data: freeUserData,
                                                area: true,
                                                showMark: false,
                                                color: '#EF476F',
                                            }]}
                                            xAxis={[{ scaleType: 'point', data: xLabels }]}
                                            yAxis={[{
                                                valueFormatter: value => value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value,
                                            }]}
                                            grid={{ vertical: false, horizontal: true }}
                                            sx={{
                                                '& path[fill^="#EF476F"]': {
                                                    fill: '#EF476F',
                                                    fillOpacity: 0.2,
                                                },
                                                '& .MuiChartsAxis-line, & .MuiChartsAxis-tick': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsGrid-line': {
                                                    stroke: '#B1B1B1',
                                                    strokeDasharray: '0',
                                                },
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Card>
                        </div>

                        <div className="col-sm-12 col-md-4 col-md-4" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box-admin">
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            TOTAL USERS
                                        </Typography>
                                        <ArrowLineUpRightIcon />
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {/* {totalusers ? totalusers.totalrecords : 0} */}
                                            {adminDatas?.totalUser}
                                        </Typography>
                                        <div className="card-div-admin">
                                            <Typography sx={{ color: adminDatas?.totaldatewaiseUsersPercentage >= 0 ? '#68C77D' : 'red', fontWeight: '12px', fontSize: '12px' }}>{/* {totalusersincrease ? ("+" + totalusersincrease.user_increase_percentage + "% increase") : '0% increase'} */}{`${adminDatas?.totaldatewaiseUsersPercentage >= 0 ? '+' : ''}${Number(adminDatas?.totaldatewaiseUsersPercentage)?.toFixed(2)}% ${adminDatas?.totaldatewaiseUsersPercentage >= 0 ? 'increase' : 'decrease'}`}</Typography>
                                        </div>
                                    </Box>

                                    <Box sx={{ border: '1px solid #ccc', borderRadius: '5px' }}/* className="box1-admin" */>
                                        {/* <LineChart
                                            width={isMobile ? 500 : 430}
                                            height={300}
                                            series={[
                                                {
                                                    data: uData,
                                                    area: true,
                                                    showMark: false,
                                                    color: '#4BA5EB', // Main line color
                                                },
                                            ]}
                                            xAxis={[
                                                {
                                                    scaleType: 'point',
                                                    data: xLabels, // Dynamically generated labels
                                                },
                                            ]}
                                            yAxis={[
                                                {
                                                    valueFormatter: (value) =>
                                                        value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value, // Format 1k, 3k, 5k
                                                },
                                            ]}
                                            grid={{ vertical: false, horizontal: true }}
                                            sx={{
                                                '& path[fill^="#4BA5EB"]': {
                                                    fill: '#4BA5EB',
                                                    fillOpacity: 0.2, // Partial transparency
                                                },
                                                '& .MuiChartsAxis-line': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsAxis-tick': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsGrid-line': {
                                                    stroke: '#B1B1B1',
                                                    strokeDasharray: '0',
                                                },
                                            }}
                                        /> */}
                                        <LineChart
                                            width={isMobile ? 500 : 430}
                                            height={300}
                                            series={[{
                                                data: totalUserData,
                                                area: true,
                                                showMark: false,
                                                color: '#06D6A0',
                                            }]}
                                            xAxis={[{ scaleType: 'point', data: xLabels }]}
                                            yAxis={[{
                                                valueFormatter: value => value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value,
                                            }]}
                                            grid={{ vertical: false, horizontal: true }}
                                            sx={{
                                                '& path[fill^="#06D6A0"]': {
                                                    fill: '#06D6A0',
                                                    fillOpacity: 0.2,
                                                },
                                                '& .MuiChartsAxis-line, & .MuiChartsAxis-tick': {
                                                    display: 'none',
                                                },
                                                '& .MuiChartsGrid-line': {
                                                    stroke: '#B1B1B1',
                                                    strokeDasharray: '0',
                                                },
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Card>
                        </div>

                    </div>

                    <div className="row d-flex align-items-center justify-content-between" style={{ marginTop: isMobile ? "2%" : "1%" }}>

                        <div className="col-sm-12 col-md-3 col-md-3">
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box3-admin">
                                        <BlogsIcon />
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            Blogs
                                        </Typography>
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {/* 10,000 */}
                                            {adminDatas?.totalBlogs}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </div>

                        <div className="col-sm-12 col-md-3 col-md-3" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box3-admin">
                                        <ImagesIcon />
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            IMAGES
                                        </Typography>
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {/* 12,000 */}
                                            {adminDatas?.totalImages}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </div>

                        <div className="col-sm-12 col-md-3 col-md-3" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box3-admin">
                                        <VideosIcon />
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            VIDEOS
                                        </Typography>
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {/* 500 */}
                                            {adminDatas?.videos}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </div>

                        {/* <div className="col-sm-12 col-md-2 col-md-2" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box3-admin">
                                        <VideoClipIcon />
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            VIDEO CLIPS
                                        </Typography>
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            12,000
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </div> */}

                        <div className="col-sm-12 col-md-3 col-md-3" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box3-admin">
                                        <AudioIcon />
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            AUDIO
                                        </Typography>
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            {/* 50 */}
                                            {adminDatas?.audios}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </div>

                        {/* <div className="col-sm-12 col-md-2 col-md-2" style={{ marginTop: isMobile ? '2%' : '' }}>
                            <Card className="card-admin">
                                <Box sx={{ padding: '6%' }}>
                                    <Box className="box3-admin">
                                        <AudioClipIcon />
                                        <Typography sx={{ color: '#767676', fontSize: '16px', fontWeight: 'bold' }}>
                                            AUDIO CLIPS
                                        </Typography>
                                    </Box>

                                    <Box className="box1-admin">
                                        <Typography sx={{ color: '#000', fontSize: '32px', fontWeight: 'bold' }}>
                                            500
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </div> */}

                    </div>

                    <div className="row d-flex align-items-center justify-content-between" style={{ marginTop: isMobile ? "2%" : "3%" }}>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <p style={{ fontWeight: 'bold', fontSize: '24px', color: '#0B0C14' }}>User Details</p>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end" style={{ gap: '10px' }}>
                            <Button
                                variant="contained"
                                startIcon={<PersonAddIcon />}
                                onClick={handleOpenAddPartnerModal}
                                style={{ backgroundColor: '#4BA5EB', color: '#fff', textTransform: 'none', marginRight: '10px' }}
                            >
                                Add New Partner
                            </Button>
                            <LoadingButton
                                variant="outlined"
                                loading={isUserListLoading}
                                loadingPosition="start"
                                startIcon={<RefreshIcon />}
                                onClick={handleRefreshUserList}
                                style={{ borderColor: '#CBCBCB', color: '#000', textTransform: 'none' }}
                            >
                                Refresh
                            </LoadingButton>
                        </div>
                    </div>

                    <div className="row d-flex align-items-center justify-content-between">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <TextField
                                style={{ border: '1px solid #ccc', borderRadius: '5px', width: isMobile ? '100%' : '60%', marginTop: '0%', height: '80%', background: '#fff' }}
                                placeholder="Search by name or email"
                                size="small"
                                value={searchText}
                                onChange={handleInputChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon sx={{ color: '#7A7A7A' }} />
                                        </InputAdornment>
                                    ),
                                }}
                                inputProps={{
                                    sx: {
                                        '::placeholder': {
                                            color: '#7A7A7A',
                                            opacity: 1,
                                        },
                                    },
                                }}
                            />
                        </div>

                        {isMobile ? <div className="col-sm-12" style={{ marginTop: '1%' }}>
                            <div className="toggle-group-admin" style={{ width: '100%' }}>
                                {filteroptions.map((option: any) => (
                                    <button
                                        key={option}
                                        className={active === option ? "active" : ""}
                                        onClick={() => setActive(option)}
                                        style={{ width: '25%' }}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div>
                        </div> : ''}

                        <div className="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end gap-2" style={{ marginTop: isMobile ? '1%' : '' }}>
                            {!isMobile ? <div className="toggle-group-admin">
                                {filteroptions.map((option: any) => (
                                    <button
                                        key={option}
                                        className={active === option ? "active" : ""}
                                        onClick={() => setActive(option)}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div> : ''}
                            {/* <div style={{ border: '1px solid #ccc', borderRadius: '8px', color: '#000', display: 'inline-flex', overflow: 'hidden', background: '#fff', padding: '8px 14px', width: isMobile ? '70%' : '' }}>
                                <FilterListIcon />{fromDatefromActiveTab && toDatefromActiveTab ? `${format(new Date(fromDatefromActiveTab), 'dd MMM')}. - ${format(new Date(toDatefromActiveTab), 'dd MMM')}.` : ''}
                            </div> */}
                            <div onClick={handleOpen} style={{ border: '1px solid #ccc', borderRadius: '8px', color: '#000', display: 'inline-flex', overflow: 'hidden', background: '#fff', padding: '8px 14px', width: isMobile ? '70%' : '', cursor: 'pointer' }}>
                                <FilterListIcon />{fromDatefromActiveTab && toDatefromActiveTab
                                    ? `${format(new Date(fromDatefromActiveTab), 'dd MMM, yyyy')} - ${format(new Date(toDatefromActiveTab), 'dd MMM, yyyy')}`
                                    : 'Select date range'}{/* {fromDatefromActiveTab && toDatefromActiveTab ? `${format(new Date(fromDatefromActiveTab), 'dd MMM')}. - ${format(new Date(toDatefromActiveTab), 'dd MMM')}.` : ''} */}
                            </div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Popover
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                >
                                    <Box p={2} display="flex" flexDirection="column" gap={2}>
                                        <DatePicker
                                            label="From Date"
                                            value={fromDate}
                                            onChange={(newValue) => setFromDate(newValue)}
                                            slotProps={{ textField: { size: 'small' } }}
                                        />
                                        <DatePicker
                                            label="To Date"
                                            value={toDate}
                                            onChange={(newValue) => setToDate(newValue)}
                                            slotProps={{ textField: { size: 'small' } }}
                                        />
                                    </Box>
                                </Popover>
                            </LocalizationProvider>
                        </div>
                    </div>

                    <div className="row">
                        {isBrowser ?
                            <>
                                <Box
                                    component={Paper}
                                    sx={{
                                        marginTop: '2%',
                                        width: '100%',
                                        border: '2px solid #D0D5DD',
                                        borderRadius: '12px',
                                        overflowX: 'auto',
                                    }}
                                >
                                    <Box sx={{ minWidth: 900 }}>
                                        {/* Header row - looks like a table head, but is just a styled div/grid */}
                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: userTableGridColumns,
                                                alignItems: 'center',
                                                height: '86px',
                                                backgroundColor: '#fff',
                                                borderBottom: '2px solid #D0D5DD',
                                            }}
                                        >
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>NAME</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>PARTNER</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>PARTNER TYPE</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>EMAIL</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>PLAN</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>REG. DATE</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>STATUS</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>SET AS PARTNER ADMIN</Box>
                                            <Box sx={{ textAlign: 'center', fontWeight: 'bold', color: '#000' }}>ACTION</Box>
                                        </Box>

                                        {/* Body rows - each is a plain div/grid row, styled to look like a table row */}
                                        {userlists && userlists.length > 0 ? userlists.map((user, index) => (
                                            <Box
                                                key={user._id}
                                                sx={{
                                                    display: 'grid',
                                                    gridTemplateColumns: userTableGridColumns,
                                                    alignItems: 'center',
                                                    minHeight: '64px',
                                                    padding: '10px 0',
                                                    backgroundColor: '#fff',
                                                    borderBottom: '2px solid #D0D5DD',
                                                }}
                                            >
                                                <Box sx={{ color: 'black', fontSize: 14, textAlign: 'left', px: 1 }}>{user.name}</Box>
                                                <Box sx={{ color: 'black', fontSize: 14, textAlign: 'left', px: 1 }}>{user.partner}</Box>
                                                <Box sx={{ color: 'black', fontSize: 14, textAlign: 'left', px: 1 }}>{user.partner_type}</Box>
                                                <Box sx={{ color: 'black', fontSize: 14, textAlign: 'left', px: 1, wordBreak: 'break-word' }}>{user.email}</Box>
                                                <Box sx={{ color: 'black', fontSize: 14, textAlign: 'left', px: 1 }}>
                                                    {(user.subscription_level === 'level_0' || user.subscription_level === 'level_4') ? 'STARTER' :
                                                        (user.subscription_level === 'level_1' || user.subscription_level === 'level_5') ? 'CREATOR' :
                                                            (user.subscription_level === 'level_2' || user.subscription_level === 'level_6') ? 'PROFESSIONAL' :
                                                                (user.subscription_level === 'level_3' || user.subscription_level === 'level_7') ? 'ENTERPRISE' :
                                                                    (user.subscription_level === 'level_0a') ? 'Life Time - STARTER' :
                                                                        (user.subscription_level === 'level_1a') ? 'Life Time - CREATOR' :
                                                                            (user.subscription_level === 'level_2a') ? 'Life Time - PROFESSIONAL' :
                                                                                (user.subscription_level === 'level_3a') ? 'Life Time - ENTERPRISE' :
                                                                                    'No Plan Subscribed'}
                                                </Box>
                                                <Box sx={{ color: 'black', fontSize: 14, textAlign: 'left', px: 1 }}>{user.created_at.split("T")[0]}</Box>
                                                <Box sx={{ textAlign: 'center', cursor: 'pointer' }}>
                                                    {user.status ? (user.status === 'active' ? <Button variant="contained" style={{ color: 'black', backgroundColor: 'lightgreen', height: '30px', width: '60%' }}>{'Active'}</Button> : <Button variant="contained" style={{ color: 'white', backgroundColor: 'red', height: '30px', width: '74%' }}>{'InActive'}</Button>) : <Button variant="contained" style={{ color: 'black', backgroundColor: 'lightgreen', height: '30px', width: '60%' }}>{'Active'}</Button>}
                                                </Box>
                                                <Box sx={{ textAlign: 'center' }}>
                                                    <Select
                                                        size="small"
                                                        displayEmpty
                                                        open={openPartnerFor === user.email}
                                                        onOpen={() => setOpenPartnerFor(user.email)}
                                                        onClose={() => setOpenPartnerFor(null)}
                                                        value={selectedPartners[user.email] ?? user.partner ?? ''}
                                                        onChange={(e) => {
                                                            handlePartnerChange(user, e.target.value as string);
                                                            setOpenPartnerFor(null);
                                                        }}
                                                        sx={{ minWidth: 140, backgroundColor: '#fff' }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {partnerData?.items?.map((partner: any) => (
                                                            <MenuItem key={partner._id} value={partner.partner_name}>
                                                                {partner.partner_name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Box>
                                                <Box sx={{ textAlign: 'center', cursor: 'pointer' }}>
                                                    {user.status ? (user.status === 'inactive' ? <Tooltip title="Activate User"><SvgIcon style={{ color: 'dodgerblue' }} component={PersonAddAlt1Icon} inheritViewBox onClick={() => handleActivateUser(user.email, index, userlists)}>{'Activate'} </SvgIcon></Tooltip> : <Tooltip title="Deactivate User"><SvgIcon aria-label="Deactivate user" style={{ color: "red" }} component={PersonAddDisabledIcon} inheritViewBox onClick={() => handleDeactivateUser(user.email, index, userlists)}>{'Deactivate'}  </SvgIcon></Tooltip>) : <Tooltip title="Activate user"><SvgIcon aria-label="Activate user" style={{ color: "red" }} component={PersonAddDisabledIcon} inheritViewBox onClick={() => handleDeactivateUser(user.email, index, userlists)}>{'Deactivate'}  </SvgIcon></Tooltip>}
                                                </Box>
                                            </Box>
                                        )) : (
                                            <Box sx={{ padding: '16px', textAlign: 'center', color: 'black' }}>
                                                {'No Data Available'}
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                                <br />
                            </> :
                            <Box style={{ backgroundColor: '#F9FBFC', height: '100%', padding: '1%', borderRadius: '5px', marginTop: '2%' }}>
                                {/* <Grid container>
                                        <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                            <Typography color="#000"
                                                variant="h6"
                                                fontWeight={900}>S.No:</Typography>
                                        </Grid>
                                        <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                            <Typography color="#000"
                                                variant="h6"
                                                fontWeight={400}>{index + 1 + (currentPage - 1) * pageSize}</Typography>
                                        </Grid>
                                    </Grid>  */}
                                {userlists ? userlists.map((user, index) => (
                                    <Stack>
                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Name:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>{user.name}</Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Partner:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>{user.partner}</Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Partner Type:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>{user.partner_type}</Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Email:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>{user.email}</Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Plan:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>
                                                    {(user.subscription_level === 'level_0' || user.subscription_level === 'level_4') ? 'STARTER' :
                                                        (user.subscription_level === 'level_1' || user.subscription_level === 'level_5') ? 'CREATOR' :
                                                            (user.subscription_level === 'level_2' || user.subscription_level === 'level_6') ? 'PROFESSIONAL' :
                                                                (user.subscription_level === 'level_3' || user.subscription_level === 'level_7') ? 'ENTERPRISE' :
                                                                    (user.subscription_level === 'level_0a') ? 'Life Time - STARTER' :
                                                                        (user.subscription_level === 'level_1a') ? 'Life Time - CREATOR' :
                                                                            (user.subscription_level === 'level_2a') ? 'Life Time - PROFESSIONAL' :
                                                                                (user.subscription_level === 'level_3a') ? 'Life Time - ENTERPRISE' :
                                                                                    'No Plan Subscribed'}
                                                </Typography>
                                                {/* {user.campaigns.map((campaign, index) => (
                                                <React.Fragment>
                                                    <div key={index}>
                                                        <Typography color="#000"
                                                            variant="h6"
                                                            fontWeight={400}><span style={{ color: 'black', fontWeight: 'bold' }}>CampaignName:</span> {campaign.product_name}</Typography>
                                                        <Typography color="#000"
                                                            variant="h6"
                                                            fontWeight={400}><span style={{ color: 'black', fontWeight: 'bold' }}>URL:</span> {campaign.url}</Typography>
                                                        <Typography color="#000"
                                                            variant="h6"
                                                            fontWeight={400}><span style={{ color: 'black', fontWeight: 'bold' }}>Mode:</span> {campaign.mode}</Typography>
                                                        <Typography color="#000"
                                                            variant="h6"
                                                            fontWeight={400}><span style={{ color: 'black', fontWeight: 'bold' }}>SubscriptionLevel:</span> {campaign.subscription_level}</Typography>
                                                        <Typography color="#000"
                                                            variant="h6"
                                                            fontWeight={400}><span style={{ color: 'black', fontWeight: 'bold' }}>ExpiryDate:</span> {campaign.expiry_date}</Typography>
                                                        <Typography color="#000"
                                                            variant="h6"
                                                            fontWeight={400}><span style={{ color: 'black', fontWeight: 'bold' }}>Blogs/month:</span> {campaign.monthly_blogs}</Typography>
                                                    </div>
                                                    <br />
                                                </React.Fragment>
                                            ))} */}
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Reg. Date:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>{user.created_at.split("T")[0]}</Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Status:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>{user.status ? (user.status === 'active' ? <Button variant="contained" style={{ color: 'black', backgroundColor: 'lightgreen', height: '30px', width: '60%' }}>{'Active'}</Button> : <Button variant="contained" style={{ color: 'white', backgroundColor: 'red', height: '30px', width: '74%' }}>{'InActive'}</Button>) : <Button variant="contained" style={{ color: 'black', backgroundColor: 'lightgreen', height: '30px', width: '60%' }}>{'Active'}</Button>}</Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>
                                                    Set as Partner Admin:
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={7}>
                                                <Select
                                                    size="small"
                                                    displayEmpty
                                                    fullWidth
                                                    open={openPartnerFor === user.email}
                                                    onOpen={() => setOpenPartnerFor(user.email)}
                                                    onClose={() => setOpenPartnerFor(null)}
                                                    value={selectedPartners[user.email] ?? user.partner ?? ''}
                                                    onChange={(e) => {
                                                        handlePartnerChange(user, e.target.value as string);
                                                        setOpenPartnerFor(null);
                                                    }}
                                                    sx={{ backgroundColor: '#fff' }}
                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {partnerData?.items?.map((partner: any) => (
                                                        <MenuItem key={partner._id} value={partner.partner_name}>
                                                            {partner.partner_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item xs={5} md={5} lg={5} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={900}>Action:</Typography>
                                            </Grid>
                                            <Grid item xs={7} md={7} lg={7} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400} style={{ cursor: 'pointer' }}>{user.status ? (user.status === 'inactive' ? <Tooltip title="Activate user"><SvgIcon style={{ color: 'dodgerblue' }} component={PersonAddAlt1Icon} inheritViewBox onClick={() => handleActivateUser(user.email, index, userlists)}>{'Activate'} </SvgIcon></Tooltip> : <Tooltip title="Deactivate user"><SvgIcon aria-label="Deactivate user" style={{ color: "red" }} component={PersonAddDisabledIcon} inheritViewBox onClick={() => handleDeactivateUser(user.email, index, userlists)}>{'Deactivate'}  </SvgIcon></Tooltip>) : <Tooltip title="Activate user"><SvgIcon aria-label="Activate user" style={{ color: "red" }} component={PersonAddDisabledIcon} inheritViewBox onClick={() => handleDeactivateUser(user.email, index, userlists)}>{'Deactivate'}  </SvgIcon></Tooltip>}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider style={{
                                            margin: '1%', flexShrink: '0px', borderWidth: '0px', borderStyle: 'solid',
                                            borderColor: '#000', borderBottomWidth: 'thin'
                                        }} />
                                    </Stack>
                                )) :
                                    <Stack>
                                        <Grid container>
                                            <Grid item xs={12} md={12} lg={12} style={{ padding: '1%' }}>
                                                <Typography color="#000"
                                                    variant="h6"
                                                    fontWeight={400}>No users Available</Typography>
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                }
                            </Box>
                        }
                    </div>

                    <div className="row" style={{ marginTop: '1%', marginBottom: '2%' }}>
                        <div className="col-12" style={{ display: 'flex', justifyContent: 'center' }}>
                            <Pagination
                                count={totalPages/* selectedBlogTitle || fromDate || toDate ? totalPagesFiltered : Math.ceil((getBlogsCount?.data ?? 0) / pageSize) */}
                                page={currentPage}
                                onChange={(event: any, value: any) => setCurrentPage(value)}
                                color="primary"
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        backgroundColor: '#fff',
                                        color: '#000',
                                        borderRadius: '4px',
                                        padding: '0.4rem',
                                        fontSize: '0.875rem',
                                        margin: '0 0.2rem',
                                        border: '1px solid #CBCBCB'
                                    },
                                    '& .Mui-selected': {
                                        backgroundColor: '#ffff',
                                        color: '#4BA5EB',
                                        border: '1px solid #4BA5EB'
                                    },
                                    '& .MuiPaginationItem-ellipsis': {
                                        backgroundColor: 'transparent',
                                        color: '#000',
                                    },
                                    '& .MuiPaginationItem-icon': {
                                        color: '#000',
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>

            </div>

            <Dialog
                open={isAddPartnerModalOpen}
                onClose={handleCloseAddPartnerModal}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Add New Partner</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} style={{ marginTop: '8px' }}>
                        <TextField
                            label="Partner Name"
                            placeholder="Enter partner name"
                            fullWidth
                            autoFocus
                            value={newPartnerName}
                            onChange={(e) => {
                                setNewPartnerName(e.target.value);
                                if (e.target.value.trim()) setNewPartnerNameError('');
                            }}
                            error={!!newPartnerNameError}
                            helperText={newPartnerNameError}
                            disabled={isAddingPartner}
                        />
                        <Box>
                            <Typography
                                variant="subtitle2"
                                style={{ fontWeight: 600, color: '#000', marginBottom: '4px' }}
                            >
                                Status
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={newPartnerStatus}
                                        onChange={(e) => setNewPartnerStatus(e.target.checked)}
                                        disabled={isAddingPartner}
                                    />
                                }
                                label={newPartnerStatus ? 'Active' : 'Inactive'}
                            />
                        </Box>
                    </Stack>
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px' }}>
                    <Button
                        onClick={handleCloseAddPartnerModal}
                        disabled={isAddingPartner}
                        style={{ textTransform: 'none', color: '#000' }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        loading={isAddingPartner}
                        loadingPosition="start"
                        startIcon={<PersonAddIcon />}
                        onClick={handleAddPartnerSubmit}
                        style={{ backgroundColor: '#4BA5EB', color: '#fff', textTransform: 'none' }}
                    >
                        Add Partner
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DashboardNew;